// Single source of truth for how each task TYPE looks & behaves in the UI:
// icon (Font Awesome), accent color, bootstrap badge variant, the related
// entity module, and a router location to "open" that entity.
//
// Used by the board cards, the list table and the detail modal so every task
// type gets its own tailored, consistent design.

const META = {
  GENERAL: { icon: 'fa-solid fa-clipboard-list', color: '#6e6b7b', variant: 'secondary', module: 'NONE' },
  CALL_CLIENT: { icon: 'fa-solid fa-phone', color: '#28c76f', variant: 'success', module: 'CLIENT' },
  FOLLOW_UP_CLIENT: { icon: 'fa-solid fa-rotate-right', color: '#00cfe8', variant: 'info', module: 'CLIENT' },
  REASSIGN_CLIENT: { icon: 'fa-solid fa-user-pen', color: '#7367f0', variant: 'primary', module: 'CLIENT' },
  CONTACT_LEAD: { icon: 'fa-solid fa-headset', color: '#00cfe8', variant: 'info', module: 'LEAD' },
  PROMOTE_LEAD: { icon: 'fa-solid fa-arrow-trend-up', color: '#28c76f', variant: 'success', module: 'LEAD' },
  HANDLE_TRANSACTION: { icon: 'fa-solid fa-money-bill-transfer', color: '#ff9f43', variant: 'warning', module: 'MONETARY' },
  REVIEW_WITHDRAWAL: { icon: 'fa-solid fa-money-bill-wave', color: '#ea5455', variant: 'danger', module: 'MONETARY' },
  REVIEW_KYC: { icon: 'fa-solid fa-id-card', color: '#7367f0', variant: 'primary', module: 'CLIENT' },
  CHECK_REPORT: { icon: 'fa-solid fa-chart-line', color: '#00cfe8', variant: 'info', module: 'REPORT' },
  REVIEW_CLIENT_REPORT: { icon: 'fa-solid fa-list-check', color: '#007BFF', variant: 'primary', module: 'REPORT' },
}

const DEFAULT = { icon: 'fa-solid fa-clipboard-list', color: '#6e6b7b', variant: 'secondary', module: 'NONE' }

export function taskMeta(type) {
  return META[type] || DEFAULT
}

// Build a router location that opens the related entity (or null).
export function relatedRoute(task) {
  if (!task) return null
  const mod = task.relatedModule || taskMeta(task.type).module
  if (!task.relatedId && mod !== 'REPORT') return null
  switch (mod) {
    case 'CLIENT':
      return { name: 'client', params: { clientId: task.relatedId } }
    case 'LEAD':
      return { name: 'leads' }
    case 'MONETARY':
      return { name: 'monetaries' }
    case 'REPORT':
      return { name: 'clientDashboard' }
    default:
      return null
  }
}

export const TASK_TYPES = Object.keys(META)
// ON_HOLD intentionally excluded from the selectable statuses (no "hold" option).
export const TASK_STATUSES = ['NEW', 'IN_PROGRESS', 'DONE', 'CANCELLED']
export const BOARD_STATUSES = ['NEW', 'IN_PROGRESS', 'DONE']
export const TASK_PRIORITIES = ['LOW', 'MEDIUM', 'HIGH', 'URGENT']

export const STATUS_VARIANT = {
  NEW: 'info', IN_PROGRESS: 'warning', ON_HOLD: 'secondary', DONE: 'success', CANCELLED: 'danger',
}
export const PRIORITY_VARIANT = {
  LOW: 'light-secondary', MEDIUM: 'light-info', HIGH: 'light-warning', URGENT: 'light-danger',
}
export const PRIORITY_COLOR = {
  LOW: '#b8c2cc', MEDIUM: '#00cfe8', HIGH: '#ff9f43', URGENT: '#ea5455',
}

export default META
